import { Component, Vue } from "vue-property-decorator";
import style from "./HeadlineSeparator.component.module.scss";

@Component
export class HeadlineSeparator extends Vue {
  render() {
    return <div class={style.headlineSeparator} />;
  }
}
